import styled, { css, CSSProperties } from 'styled-components';
import { Steps as UiSteps } from 'components/UI/Steps';
import { isMobile } from 'utils';
import { numericToPx } from 'utils/styles/numeric-to-px';
import { DEVICE } from 'constants/app/breakpoints';

export const StepViewerWrapper = styled.div`
  overflow: hidden;
  border-radius: 24px;
  height: 100%;
  width: 100%;
  z-index: 1;
  ${isMobile() &&
  css`
    height: 100vh;
  `}
`;

export const StepViewer = styled.div<{
  $width?: CSSProperties['width'];
  $height?: CSSProperties['height'];
  $withoutWrapper?: boolean;
}>`
  position: relative;
  overflow: auto;
  width: ${({ $width }) => numericToPx($width) || '100%'};
  height: ${({ $height }) => numericToPx($height) || '100%'};
  border-radius: 24px;
  border: 1px solid var(--v3-black-2);
  background: var(--v3-black-0);
  padding: 0 ${isMobile() ? 20 : 32}px;
  display: flex;
  flex-direction: column;
  z-index: 1;

  ${isMobile() &&
  css`
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 3;
    max-height: 624px;
  `}

  ${({ $withoutWrapper }) =>
    $withoutWrapper &&
    css`
      border-radius: 0;
      border: none;
      overflow: unset;
    `}
`;

export const StepViewerHeader = styled.div<{ $isSticky: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  border-bottom: 1px solid var(--v3-black-2);
  background: var(--v3-black-0);
  padding: 24px 0;

  @media screen and ${DEVICE.xl} {
    padding: 24px;
  }

  ${props =>
    !isMobile() &&
    props.$isSticky &&
    css`
      position: sticky;
      top: 0;
      z-index: 50;
    `}
`;

export const StepViewerHeaderTitle = styled.h3`
  margin: 0;
  padding: 0;
  font-weight: 800;
  font-size: 22px;
  line-height: 32px;
  letter-spacing: -0.02em;
  color: var(--v3-text-color);

  ${isMobile() &&
  css`
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
  `}
`;

export const StepViewerHeaderSubtitle = styled.h4`
  margin: 0;
  padding: 0;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.02em;
  color: var(--v3-text-color-secondary);
`;

export const StepsWrapper = styled.div<{ $isStepsText: boolean }>`
  margin-top: 20px;
  display: flex;
  gap: 8px;
  justify-content: space-between;
  align-items: center;

  ${({ $isStepsText }) =>
    $isStepsText &&
    css`
      margin-top: 4px;
    `}
`;

export const StepsWrapperLeft = styled.div`
  flex: 1;
  overflow-y: hidden;
  overflow-x: auto;
  width: 100%;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const StepsAsText = styled.div`
  color: var(--v3-black-45);
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.3px;
`;

export const Steps = styled(UiSteps)`
  && {
    width: fit-content;
  }
`;

export const StepViewerBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px 0 0;
  background-color: var(--v3-black-0);
`;

export const StepViewerBodyStepWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export const StepViewerBodyLoaderFallback = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const StepViewerFooter = styled.div<{ $contentFixed?: boolean }>`
  position: sticky;
  background: var(--v3-black-0);
  bottom: 0;
  left: 0;
  right: 0;
  margin-left: -${isMobile() ? 20 : 32}px;
  margin-right: -${isMobile() ? 20 : 32}px;
  padding: 10px 16px 16px;
  z-index: 1;

  ${props =>
    props.$contentFixed &&
    css`
      padding: unset;
      margin: unset;
      position: static;
      width: 0;
      height: 0;
      z-index: 0;
    `}

  @media screen and ${DEVICE.xl} {
    margin-inline: 0;
  }
`;
